import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faFilter,
  faSquareFull,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { triggerBase64Download } from "common-base64-downloader-react";
import { Container, Row, Col, InputGroup, Button, Form } from "react-bootstrap";

import TableApprovedForInterviewList from "./Components/TableApprovedForInterviewList";
import PaginationList from "../../2.Common/Pagination";

import {
  getHRApprovedInterviewListPagination,
  getHRApprovedInterviewListSearch,
  updateSearchApprovedInterviewList,
  updateCurrentApproveInterviewPage,
  postExcelFileCirculation,
} from "../../4.Store/HRTableListSlice";
import { getSupervisorList } from "../../4.Store/CirculationSlice";

const ApprovedForInterviewList = () => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const [showFilter, setShowFilter] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [positionApplied, setPositionApplied] = useState("");
  const [salaryRangeFrom, setSalaryRangeFrom] = useState(0);
  const [salaryRangeTo, setSalaryRangeTo] = useState(0);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [source, setSource] = useState("");
  const [statusApplication, setStatusApplication] = useState("");
  const [supervisors, setSupervisors] = useState([]);
  const [supervisorDropdown, setSupervisorDropdown] = useState("");
  const [column, setColumn] = useState("date");
  const [columnDirection, setColumnDirection] = useState(-1);
  const [dateApprovalFrom, setDateApprovalFrom] = useState();
  const [dateApprovalTo, setDateApprovalTo] = useState();
  const [dateInterviewFrom, setDateInterviewFrom] = useState();
  const [dateInterviewTo, setDateInterviewTo] = useState();

  const {
    circulationListByStatus,
    currentApproveInterviewPage,
    totalCurrentApproveInterviewPage,
    searchCirculationListByStatus,
    searchKeyWordCirculationListByStatusLists,
  } = useSelector((store) => store.HRTableList);

  const parseSearchInput = (searchText) => {
    const words = searchText.split(" ");
    const searchObject = {};

    let currentKey = "";
    let keyword = "";

    words.forEach((word) => {
      if (word.includes(":")) {
        const [key, value] = word.split(":");
        const cleanKey = key.trim();
        const cleanValue = value.trim();
        currentKey = cleanKey;
        searchObject[currentKey] = searchObject[currentKey]
          ? searchObject[currentKey] + " " + cleanValue
          : cleanValue;
      } else {
        if (currentKey === "") {
          keyword += word + " ";
        } else {
          searchObject[currentKey] += " " + word;
        }
      }
    });

    searchObject["keyword"] = keyword.trim();

    return searchObject;
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      const parsedObject = parseSearchInput(
        searchKeyWordCirculationListByStatusLists
      );

      if (searchKeyWordCirculationListByStatusLists) {
        dispatch(
          getHRApprovedInterviewListSearch({
            parsedObject,
            column,
            columnDirection,
          })
        );
      } else {
        dispatch(
          getHRApprovedInterviewListPagination({
            pageNo: currentApproveInterviewPage,
            pageSize: 20,
            column,
            columnDirection,
          })
        );
      }
    }

    if (event.keyCode === 13) {
      event.preventDefault();

      const parsedObject = parseSearchInput(
        searchKeyWordCirculationListByStatusLists
      );
      dispatch(
        getHRApprovedInterviewListSearch({
          parsedObject,
          column,
          columnDirection,
        })
      );
      // handleSearchClick(event);
    }
  };

  const setClearKeyword = () => {
    setPositionApplied("");
    setSource("");
    setDateFrom("");
    setDateTo("");
    setDateApprovalFrom("");
    setDateApprovalTo("");
    setDateInterviewFrom("");
    setDateInterviewTo("");
    setSalaryRangeFrom(0);
    setSalaryRangeTo(0);
    setKeyword("");
    setStatusApplication("");

    dispatch(updateSearchApprovedInterviewList(""));
    dispatch(
      getHRApprovedInterviewListPagination({
        pageNo: currentApproveInterviewPage,
        pageSize: 20,
        column,
        columnDirection,
      })
    );
  };

  useEffect(() => {
    dispatch(getSupervisorList()).then((res) => {
      const arr = [];
      let result = res.payload;

      result.map((supervisor) => {
        const capitalizedSupervisorName = supervisor.name.toUpperCase();

        return arr.push({
          value: supervisor.id,
          label: capitalizedSupervisorName,
          email: supervisor.email,
        });
      });

      arr.sort((a, b) => a.label.localeCompare(b.label));

      setSupervisors(arr);
    });
  }, []);

  useEffect(() => {
    if (showFilter) {
      const parsedObject = parseSearchInput(
        searchKeyWordCirculationListByStatusLists
      );
      setKeyword(parsedObject.keyword);
      setSupervisorDropdown(parsedObject.supervisor);
      setPositionApplied(parsedObject.positionApplied);
      setSource(parsedObject.source);
      setDateFrom(parsedObject.dateFrom);
      setDateTo(parsedObject.dateTo);
      setSalaryRangeFrom(parsedObject.salaryFrom);
      setSalaryRangeTo(parsedObject.salaryTo);
      setStatusApplication(parsedObject.statusApplication);
      setDateApprovalFrom(parsedObject.setDateApprovalFrom);
      setDateApprovalTo(parsedObject.setDateApprovalTo);
      setDateInterviewFrom(parsedObject.setDateInterviewFrom);
      setDateInterviewTo(parsedObject.setDateInterviewTo);
    }

    // const handleClickOutside = (event) => {
    //   if (formRef.current && !formRef.current.contains(event.target)) {
    //     setShowFilter(false);
    //   }
    // };

    // if (showFilter) {
    //   document.addEventListener("mousedown", handleClickOutside);
    // } else {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // }

    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, [showFilter]);

  useEffect(() => {
    const fromLSKeyword = localStorage.getItem(
      searchKeyWordCirculationListByStatusLists
    );
    if (fromLSKeyword) {
      dispatch(updateSearchApprovedInterviewList(fromLSKeyword));
    }

    if (!searchKeyWordCirculationListByStatusLists) {
      dispatch(
        getHRApprovedInterviewListPagination({
          pageNo: currentApproveInterviewPage,
          pageSize: 20,
          column,
          columnDirection,
        })
      );
    }
  }, [currentApproveInterviewPage]);

  const handlePagination = (page) => {
    dispatch(updateCurrentApproveInterviewPage(page));
  };

  const handleClickDownloadExcel = () => {
    dispatch(postExcelFileCirculation()).then((res) => {
      // console.log(res);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload;
      triggerBase64Download(
        base64EXCEL,
        "Approved For Interview List" +
          "_" +
          new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleClickFilterSearch = () => {
    const parts = [];

    if (keyword) parts.push(`${keyword}`);
    if (supervisorDropdown) parts.push(`supervisor:${supervisorDropdown}`);
    if (positionApplied) parts.push(`positionApplied:${positionApplied}`);
    if (source) parts.push(`source:${source}`);
    if (dateFrom) parts.push(`dateFrom:${dateFrom}`);
    if (dateTo) parts.push(`dateTo:${dateTo}`);
    if (salaryRangeFrom) parts.push(`salaryFrom:${salaryRangeFrom}`);
    if (salaryRangeTo) parts.push(`salaryTo:${salaryRangeTo}`);
    if (statusApplication) parts.push(`statusApplication:${statusApplication}`);

    if (dateApprovalFrom) parts.push(`dateApprovalFrom:${dateApprovalFrom}`);
    if (dateApprovalTo) parts.push(`dateApprovalTo:${dateApprovalTo}`);

    if (dateInterviewFrom) parts.push(`dateInterviewFrom:${dateInterviewFrom}`);
    if (dateInterviewTo) parts.push(`dateInterviewTo:${dateInterviewTo}`);

    const parsedObject = parseSearchInput(parts.join(" "));
    dispatch(
      getHRApprovedInterviewListSearch({
        parsedObject,
        column,
        columnDirection,
      })
    );

    dispatch(
      updateSearchApprovedInterviewList({
        parsedObject,
        column,
        columnDirection,
      })
    );

    setShowFilter(false);
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <InputGroup className="col-4 mb-3">
            <Form.Control
              className="form-control"
              placeholder="Search"
              onChange={({ currentTarget: input }) => {
                dispatch(updateSearchApprovedInterviewList(input.value));
              }}
              onFocus={() => setShowFilter(false)}
              onKeyDown={handleKeyDown}
              value={searchKeyWordCirculationListByStatusLists}
            />
            <Button
              variant="outline-secondary"
              onClick={() => setClearKeyword()}
            >
              <FontAwesomeIcon icon={faClose} />
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FontAwesomeIcon icon={faFilter} />
            </Button>

            {showFilter && (
              <form
                ref={formRef}
                className="filter-form position-absolute top-100 start-0 w-50"
                style={{ zIndex: 9999 }}
              >
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="keyword"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Keyword
                    </label>
                    <input
                      type="text"
                      id="keyword"
                      value={keyword}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="position"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Position
                    </label>
                    <input
                      type="text"
                      id="position"
                      placeholder="Enter Position"
                      value={positionApplied}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setPositionApplied(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="source"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      SV
                    </label>
                    <Form.Select
                      id="supervisorDropdown"
                      value={supervisorDropdown}
                      onChange={(e) => setSupervisorDropdown(e.target.value)}
                      className="border-0 border-bottom flex-grow-1"
                    >
                      <option></option>
                      {supervisors.map((option) => (
                        <option key={option.value} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="dateRange"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Date Applied
                    </label>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="From Date"
                      value={dateFrom}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateFrom(e.target.value)}
                    />
                    <div style={{ width: "15px" }}></div>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="To Date"
                      value={dateTo}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateTo(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="dateRange"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Date Approval
                    </label>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="From Date"
                      value={dateApprovalFrom}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateApprovalFrom(e.target.value)}
                    />
                    <div style={{ width: "15px" }}></div>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="To Date"
                      value={dateApprovalTo}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateApprovalTo(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="dateRange"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Date Interview
                    </label>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="From Date"
                      value={dateInterviewFrom}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateInterviewFrom(e.target.value)}
                    />
                    <div style={{ width: "15px" }}></div>
                    <input
                      type="date"
                      id="dateRange"
                      placeholder="To Date"
                      value={dateInterviewTo}
                      className="form-control border-0 border-bottom flex-grow-1"
                      onChange={(e) => setDateInterviewTo(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                  <div
                    className="mb-3 d-flex align-items-center"
                    style={{ minWidth: "150px", width: "100%" }}
                  >
                    <label
                      htmlFor="source"
                      className="form-label me-2"
                      style={{ flexBasis: "75px", minWidth: "75px" }}
                    >
                      Status
                    </label>
                    <Form.Select
                      value={statusApplication}
                      onChange={(e) => setStatusApplication(e.target.value)}
                      className="border-0 border-bottom flex-grow-1"
                    >
                      <option value=""></option>
                      <option value="INTERVIEWPENDING">
                        INTERVIEW PENDING
                      </option>
                      <option value="INTERVIEWEDCANCELED">
                        INTERVIEWED CANCELED
                      </option>
                    </Form.Select>
                  </div>
                </div>

                <div className="mb-3 d-flex flex-row-reverse">
                  <button
                    className="btn btn-primary mt-3"
                    onClick={handleClickFilterSearch}
                  >
                    Search
                  </button>
                </div>
              </form>
            )}
          </InputGroup>
        </Col>
        <Col md="auto" sm="auto">
          {searchKeyWordCirculationListByStatusLists ? (
            <PaginationList
              nPages={1}
              currentPage={1}
              handlePagination={handlePagination}
            />
          ) : (
            <PaginationList
              nPages={totalCurrentApproveInterviewPage}
              currentPage={currentApproveInterviewPage}
              handlePagination={handlePagination}
            />
          )}
        </Col>
      </Row>

      <TableApprovedForInterviewList />

      <Row className="justify-content-md-end my-2">
        <Col md="auto" sm="auto">
          <FontAwesomeIcon
            icon={faSquareFull}
            color="#DDF4FC"
            className="fa-2xl"
          />
          &nbsp; TBD
        </Col>
        <Col md="auto" sm="auto">
          <FontAwesomeIcon icon={faDownload} color="blue" />
          &nbsp; Download Biodata Only
        </Col>
        <Col md="auto" sm="auto">
          <FontAwesomeIcon icon={faDownload} color="#E1AD01" />
          &nbsp; Download
        </Col>
      </Row>

      <Row className="justify-content-md-end my-2">
        <Col md="auto" sm="auto">
          <Button
            onClick={handleClickDownloadExcel}
            variant="outline-primary"
            className="mx-3"
          >
            Download Excel File
          </Button>
        </Col>
        <Col md="auto" sm="auto">
          {searchKeyWordCirculationListByStatusLists ? (
            <PaginationList
              nPages={1}
              currentPage={1}
              handlePagination={handlePagination}
            />
          ) : (
            <PaginationList
              nPages={totalCurrentApproveInterviewPage}
              currentPage={currentApproveInterviewPage}
              handlePagination={handlePagination}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};
export default ApprovedForInterviewList;
